
export enum SpinnerName{
  APP = 'APP_SPINNER',
  LAYOUT = 'LAYOUT_SPINNER'
}